import React, { Fragment, useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import "./Users.css";
import { useDispatch, useSelector } from 'react-redux';
import { decryptData } from '../../../utils/helper';
import { patientActions } from '../../../context/reducers/patient';
import { failed, success } from '../../../utils/Tostify';
import Loader from '../../../components/Loader/Loader';
import moment from 'moment';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { activateDeactivateStaff, deleteStaff, getStaffs, getStaffsByOrgId } from '../../../api/User';
import EditUser from './EditUser';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import { ITEMS_PER_PAGE, platformLayout } from '../../../utils/constants';

function UserListing({ direction, setCurrentTab, userData, searchKey, ...args }) {
    let role = localStorage.getItem("userRole");
    let roleId = localStorage.getItem("roleId");
    const roles = useSelector((state) => state?.userReducer?.user?.roles);
    const defaultPermissions = useSelector((state) => state?.userReducer?.user?.defaultRole?.value?.permissions);
    const matchedRole = roles?.find((role) => role.value._id === roleId);
    const permissions = matchedRole?.permissions || defaultPermissions;
    const isReadonly = permissions.find((obj)=> obj?.objectName === "Users")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('read');
    const isEdit = permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('edit');
    let token = useSelector(state => state.userReducer.token);
    let staffs = useSelector(state => state.patientReducer.staffList);
    const { getConfirmation } = useConfirmDialog();
    const dispatch = useDispatch();
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [StaffData, setStaffData] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const toggleDropdown = (id) => {
        setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };

    const getStaffList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            if(role == platformLayout.Organization){
                res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId")});
            }else{
                res = await getStaffs({ dispatch, token, page, limit, searchKey});
            }
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                dispatch(patientActions.staffListing(responseData));
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleActiveInActive = async (e, staffId) => {
        // Store the current checkbox state
        const isChecked = e.target.checked;
        // Temporarily prevent checkbox from updating by setting it back to its previous state
        e.target.checked = !isChecked;
        const msg = isChecked ? "Activate" : "Deactivate";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to ${msg}?`
        });
        if (confirmed) {
            let res;
            try {
                setIsLoading(true);
                // Call API to update the staff's active state
                res = await activateDeactivateStaff({
                    dispatch,
                    token,
                    staffId,
                    isActive: isChecked
                });
                if (res?.status === "SUCCESS") {
                    await getStaffList(staffs?.currentPage, 10);
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        } else {
            // If not confirmed, set the checkbox state back to its original state
            e.target.checked = !isChecked;
        }
    };

    const handleViewUserDetail =(data)=>{
        userData(data);
        setCurrentTab("userDetails");
    };

    const handleDelete = async(userName, userId)=>{
        const isActive = staffs?.items?.find((obj)=> obj?._id == userId)?.active;
            if(isActive){
                failed("You can't delete an Active User");
                return;
            }
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to Delete ${userName}?`
        });
        if (confirmed) {
            let res;
            try {
                const values = {isDeleted: true};
                setIsLoading(true);
                res = await deleteStaff({values, dispatch, token, userId});
                if (res?.status === "SUCCESS") {
                    await getStaffList();
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
      };

    useEffect(() => {
        getStaffList();
    }, []);

    const filteredStaffList = staffs?.items?.filter((staff) => {
        const searchLower = searchKey.trim().toLowerCase();
        const searchTerms = searchLower.split(/\s+/); // Split by spaces to handle full names

        return searchTerms.every(term =>
            staff?.firstName?.toLowerCase().includes(term) ||
            staff?.lastName?.toLowerCase().includes(term) ||
            (staff?.firstName + " " + staff?.lastName)?.toLowerCase().includes(term) ||
            staff?.email?.toLowerCase().includes(term) ||
            staff?.defaultRole?.label?.toLowerCase().includes(term) ||
            staff?.city?.toLowerCase().includes(term) || // Matches only city
            staff?.state?.toLowerCase().includes(term) || // Matches only state
            `${staff?.city},${staff?.state}`.toLowerCase().includes(term)
        );
    }) || [];

    const sortedStaffList = filteredStaffList.sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aValue = a[sortConfig.key]?.toLowerCase();
        let bValue = b[sortConfig.key]?.toLowerCase();
        if (sortConfig.key === "role") {
            aValue = (a.defaultRole?.label || "").toLowerCase();
            bValue = (b.defaultRole?.label || "").toLowerCase();
        }
        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const paginatedStaffList = sortedStaffList.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    return (
        <Fragment>
            {isLoading ? <Loader /> : null}
            {showModal && <EditUser refetch={getStaffList} setCurrentTab={setCurrentTab} userData={StaffData} setShowModal={() => setShowModal(!showModal)}/>}
            <div className="organization_form_block organization_blk user_sup_containers user_container_main table_user table_listing_color ">
                <div className="table_space p-0 m-0">
                    <div className="table-wrapper">
                        <table className='scroll-table-three'>
                            <thead>
                                <tr className="header_table">
                                    <th onClick={() => handleSort("firstName")}>Full Name <i className='fas fa-sort'></i></th>
                                    <th onClick={() => handleSort("email")}>Email <i className='fas fa-sort'></i></th>
                                    <th onClick={() => handleSort("role")}>Role <i className='fas fa-sort'></i></th>
                                    <th onClick={() => handleSort("city")}>Location <i className='fas fa-sort'></i></th>
                                    <th onClick={() => handleSort("createdAt")}>Joined <i className='fas fa-sort'></i></th>
                                    {role === platformLayout.Platform ? <th>Active</th> : null}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className='scrollable-tbody-three'>
                            {paginatedStaffList?.length > 0 ? paginatedStaffList?.map((staff, index) => (
                              <Fragment key={staff._id}>
                                    <tr>
                                        <td colSpan={8} className="bg_light" ></td>
                                    </tr>
                                    <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                        <td className="text-truncate">
                                            <span
                                                style={{ cursor: "pointer", color: "#007bff"}}
                                                onClick={() => handleViewUserDetail(staff)}
                                            >
                                                {staff?.firstName + " " + staff?.lastName}
                                            </span>
                                        </td>
                                        <td className='text-truncate'>{staff?.email}</td>
                                        <td className='text-truncate'>{staff?.defaultRole?.label}</td>
                                        <td className='text-truncate'>{staff?.city + "," + staff?.state}</td>
                                        <td className='text-truncate'>{moment(staff?.createdAt).format("MMM-DD-YYYY")}</td>
                                        {role === platformLayout.Platform ? <td>
                                            <div className="toggle">
                                                <input
                                                    type="checkbox"
                                                    id={`checktoggle-${staff._id}`}
                                                    onChange={(e) => isEdit ? handleActiveInActive(e, staff._id)  : isReadonly ? null :  handleActiveInActive(e, staff._id)}
                                                    checked={staff?.active}
                                                />
                                                <label htmlFor={`checktoggle-${staff._id}`}></label>
                                            </div>
                                        </td> : null}
                                        <td>
                                            <Dropdown isOpen={dropdownOpen.includes(staff?._id)} toggle={() => isEdit ? toggleDropdown(staff._id) : isReadonly ? null : toggleDropdown(staff._id)}  direction={direction}>
                                                <DropdownToggle caret size="xl" className="column_blk">
                                                    <div className="for_details">
                                                        <i className="fa fa-ellipsis-v"></i>
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu {...args}>
                                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> handleViewUserDetail(staff)}>
                                                        <div className="add_hosp" >View Details</div>
                                                    </DropdownItem>
                                                    {/* {role === platformLayout.Platform ? staff?.active ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setStaffData(staff); setShowModal(true);}}>
                                                        <div className="add_hosp">Edit</div>
                                                    </DropdownItem> : null : null} */}
                                                    {role === platformLayout.Platform ?
                                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> handleDelete(staff?.firstName + " " + staff?.lastName, staff._id)}>
                                                        <div className="add_hosp" >Delete</div>
                                                    </DropdownItem> : null}
                                                </DropdownMenu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                    <tr className='d-none'>
                                        <td colSpan={8} className="bg_light" ></td>
                                    </tr>
                                    </Fragment>)) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                            </tbody>
                        </table>
                    </div>
                    <CustomPagination
                        tableData={filteredStaffList}
                        totalPages={Math.ceil(filteredStaffList.length / ITEMS_PER_PAGE)}
                        totalRows={filteredStaffList.length}
                        rowsPerPage={ITEMS_PER_PAGE}
                        page={currentPage}
                        handlePage={(page) => setCurrentPage(page)}
                    />
                </div>
            </div>
        </Fragment>
    );
}
export default UserListing;
